import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, FeatureType, Grid, JobType, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { JobTypeComponent } from './job-type.component'

@Component({
    selector: 'app-job-types',
    templateUrl: './job-types.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class JobTypesComponent extends BaseComponent {
    faSearch = faSearch
    public grid: Grid<JobType>

    constructor() {
        super()
        this.grid = new Grid<JobType>(this.services)
            .setupModalEditing(this.services.data.jobTypes, 'Job Type', JobTypeComponent, () => new JobType(), this, ModalSize.small)
            .filterBy(item => [item.shortName, item.fullName])
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.jobTypes.queryAll()).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.grid.items = result[0]
                },
            }),
        )
    }
    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.UsersEdit])
    }
}
